<template>
  <div class="teaching">
    <div class="teaching-content">
      <div class="teaching-img" v-if="learning === false">
        <template v-if="teachingGatherVo.image != null && teachingGatherVo.image != ''">
          <img :src=teachingGatherVo.image>
        </template>
        <template v-else>
          <img src="../assets/image/teaching-img.png">
        </template>
      </div>
      <div class="teaching-img" v-show="learning === true">
        <div class="teaching-video" ref="playerTemp"></div>
      </div>
      <div class="teaching-info">
        <div class="teaching-name">{{ teachingGatherVo.name }}</div>
        <div class="teaching-type-list"
          v-if="teachingGatherVo.firstCategoryName != null || teachingGatherVo.secondCategoryName != null">
          <div class="teaching-type-each"
            v-if="teachingGatherVo.firstCategoryName != null && teachingGatherVo.firstCategoryName != ''">{{
              teachingGatherVo.firstCategoryName }}</div>
          <div class="teaching-type-each"
            v-if="teachingGatherVo.secondCategoryName != null && teachingGatherVo.secondCategoryName != ''">{{
              teachingGatherVo.secondCategoryName }}</div>
        </div>
        <div class="teaching-price-all">
          <template v-if="teachingGatherVo.isOpen === '0'">
            <div class="teaching-price green">免费</div>
          </template>
          <template v-else>
            <div class="teaching-price red">¥ {{ teachingGatherVo.price }}</div>
          </template>
          <div class="teaching-countStudent">{{ teachingGatherVo.countStudent }} 在学</div>
        </div>
      </div>
      <div class="teaching-title">
        <div class="teaching-title-each" :class="{ 'select': pageShow === '0' }" @click="changePageShow('0')">简介</div>
        <div class="teaching-title-each" :class="{ 'select': pageShow === '1' }" @click="changePageShow('1')">课时</div>
      </div>
      <div class="teaching-descInfo" v-if="pageShow === '0'" v-html="teachingGatherVo.descInfo"></div>
      <div class="teaching-list" v-if="pageShow === '1'">
        <div class="teaching-list-each" v-for="(item, value) in teachingGatherVo.teachingList" :key="value"
          @click=checkCouldTeach(item)>
          <div class="teaching-list-index" :class="{ 'teaching-doing': learning && teachingInfo.id === item.id }">{{
            value +
            1 }}:</div>
          <template v-if="item.type === 'exam'">
            <div class="teaching-list-name">{{
              item.examName
            }}</div>
            <template v-if="item.examStatus === '0' || item.examStatus === null">
              <div class="teaching-status-icon">
                <div class="teaching-lock-icon"></div>
              </div>
            </template>
            <template v-if="item.examStatus === '1'">
              <div class="teaching-status">未完成</div>
            </template>
          </template>
          <template v-else>
            <div class="teaching-list-name" :class="{ 'teaching-doing': learning && teachingInfo.id === item.id }">{{
              item.name
            }}</div>
            <template v-if="teachingGatherVo.isOpen === '0' || teachingGatherVo.privilegeSource === '1'">
              <template v-if="item.status === '0'">
                <div class="teaching-status">未完成</div>
              </template>
            </template>
            <template v-if="teachingGatherVo.isOpen === '1' && teachingGatherVo.privilegeSource !== '1'">
              <template v-if="item.isOpen === '1'">
                <div class="teaching-status blue">试看</div>
              </template>
              <template v-if="item.isOpen === '0'">
                <div class="teaching-status-icon">
                  <div class="teaching-lock-icon"></div>
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="teaching-pay"
      v-if="teachingGatherVo.isOpen === '1' && (teachingGatherVo.privilegeSource === '0' || teachingGatherVo.privilegeSource === null)">
      <div class="teaching-pay-left">课程费用：¥ {{ teachingGatherVo.price }}</div>
      <div class="teaching-pay-right" @click="toOrderPay">立即购买</div>
    </div>
  </div>
</template>

<script>
import { getTeachingGatherDetails, getTeaching, updateTeachingLearning } from '@/api/common'
import { showToast } from 'vant';
import { wexinShare } from '../utils/wexinShare.js'
import { getWeChatAutograph } from '@/api/common'
export default {
  name: 'TeachDetailPage',
  props: ['id'],
  data() {
    return {
      merchantId: '',
      teachingId: '',
      teachingGatherVo: {},
      pageShow: '1', // 0: 简介 1：课时
      learning: false,  // 学习状态
      player: null, // 视频播放器
      options: {
        id: 'player-con',
        vid: '',
        playauth: '',
        width: '100%',
        height: '100%',
        // controlBarVisibility: 'never',
        skinLayout: [
          {
            name: "H5Loading", align: "cc"
          },
          {
            name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              // { name: "progress", align: "blabs", x: 0, y: 44 },
              { name: "playButton", align: "tl", x: 15, y: 12 },
              { name: "timeDisplay", align: "tl", x: 10, y: 7 },
              { name: "fullScreenButton", align: "tr", x: 10, y: 12 },
              // { name: "setting", align: "tr", x: 15, y: 12 },
              { name: "volume", align: "tr", x: 5, y: 10 }
            ]
          }
        ],
        useH5Prism: true,
        replay: false,
        disableSeek: false,
      },
      teachingInfo: null,
      teachingLoading: false
    }
  },
  created() {
    this.merchantId = this.id;
    this.teachingId = this.$route.query.teachingId;
    let that = this;
    window.addEventListener("beforeunload", function () {
      that.beforeunload()
    });
  },
  mounted() {
    let path = window.location.href;
    sessionStorage.setItem("iOS-URL", path);
    this.checkWeChatShare(this.merchantId);
    const script = document.createElement('script');
    script.src = 'https://g.alicdn.com/apsara-media-box/imp-web-player/2.16.3/aliplayer-min.js';
    script.onload = () => {
      // 脚本加载完毕后的操作
      if (document.getElementById('player-con') === null) {
        let playerDomWrap = this.$refs.playerTemp;
        let playerDom = document.createElement('div');
        playerDom.setAttribute('id', 'player-con');
        playerDomWrap.appendChild(playerDom);
      }
      this.getDetails(this.merchantId);
    };
    document.head.appendChild(script);
  },
  methods: {
    getDetails() {
      let params = {
        id: this.teachingId
      };
      getTeachingGatherDetails(params).then((res) => {
        this.teachingGatherVo = res.teachingGatherVo;
        if (res.teachingGatherVo.examId != 0) {
          let item = {
            'id': res.teachingGatherVo.id,
            'examName': res.teachingGatherVo.examName,
            'type': 'exam',
            'examId': res.teachingGatherVo.examId,
            'examStatus': res.teachingGatherVo.examStatus,
          }
          this.teachingGatherVo.teachingList.push(item)
        }
      })
    },
    changePageShow(index) {
      this.pageShow = index;
    },
    checkCouldTeach(item) {
      if (item.type === 'exam') {
        if (item.examStatus === null) {
          this.$router.push({
            path: '/login/' + this.merchantId
          });
        } else if (item.examStatus === '0') {
          showToast('请先完成课程学习!')
        } else {
          this.$router.push({
            path: '/examDetail/' + this.merchantId, query: {
              teachingId: this.teachingId,
            }
          });
        }
        return;
      }
      if (this.teachingGatherVo.isOpen === '0') {
        this.palyTeaching(item);
      } else if (this.teachingGatherVo.isOpen === '1') {
        if (this.teachingGatherVo.privilegeSource === null) {
          this.$router.push({
            path: '/login/' + this.merchantId
          });
          return;
        }
        if (this.teachingGatherVo.privilegeSource !== '1' && item.isOpen === '0') {
          showToast('请购买课程再进行学习!')
        } else {
          this.palyTeaching(item);
        }
      }
    },
    palyTeaching(item) {
      if (this.teachingInfo != null && item.id === this.teachingInfo.id) return;
      if (this.teachingLoading) return;
      let params = {
        id: item.id
      };
      if (this.learning === true && this.teachingInfo != null) {
        let that = this;
        new Promise(function (resolve) {
          let params = {
            id: that.teachingInfo.id,
            second: that.player.getCurrentTime(),
            finished: (that.player.getCurrentTime() / that.player.getDuration()) > parseInt(that.teachingInfo.beFinal) / 100 ? '1' : '0'
          }
          that.updateTeaching(params);
          resolve();
        });
      }
      this.teachingLoading = true;
      this.options.skinLayout[1].children = this.options.skinLayout[1].children.filter((item) => item.name !== 'setting' && item.name !== 'progress');
      getTeaching(params).then((res) => {
        this.teachingLoading = false;
        if (res.code !== 200 && res.code !== 401) {
          showToast(res.msg)
          return;
        }
        this.options.vid = res.vid;
        this.options.playauth = res.playAuth;
        if (res.playSpeed === '0') {
          let playData = { name: "setting", align: "tr", x: 15, y: 12 };
          this.options.skinLayout[1].children.push(playData)
        }
        if (res.adjustProgress === '0') {
          let playData = { name: "progress", align: "blabs", x: 0, y: 44 };
          this.options.skinLayout[1].children.push(playData)
        }
        this.learning = true;
        this.teachingInfo = res;
        this.teachingInfo.id = item.id;
        if (this.player !== null) {
          this.player.dispose();
        }
        let that = this;
        this.player = new window.Aliplayer(this.options), function (player) {
          player.play();
        };
        if (res.currentSeconds != null && res.currentSeconds > 0) {
          this.player.seek(res.currentSeconds);
        }
        this.player.on('ended', function () {
          let params = {
            id: that.teachingInfo.id,
            second: that.player.getCurrentTime(),
            finished: '1'
          }
          that.updateTeaching(params);
        });
      })
    },

    beforeunload() {
      if (this.learning === true && this.player.getStatus() === 'playing') {
        let params = {
          id: this.teachingInfo.id,
          second: this.player.getCurrentTime(),
          finished: (this.player.getCurrentTime() / this.player.getDuration()) > parseInt(this.teachingInfo.beFinal) / 100 ? '1' : '0'
        }
        this.updateTeaching(params);
      }
    },

    updateTeaching(item) {
      let params = {
        id: item.id,
        currentSeconds: item.second,
        finished: item.finished
      };
      updateTeachingLearning(params).then(() => {
      })
    },
    toOrderPay() {
      if (this.learning === true && this.player.getStatus() === 'playing') {
        this.player.pause();
      }
      if (this.teachingGatherVo.privilegeSource === null) {
        this.$router.push({
          path: '/login/' + this.merchantId
        });
        return;
      }
      this.$router.push({
        path: '/orderPay/' + this.merchantId, query: {
          teachingId: this.teachingId,
        }
      });
    },
    checkWeChatShare(merchantId) {
      //通过正则表达式匹配broser 中是否含有MicroMessenger字符串
      var broser = window.navigator.userAgent.toLowerCase();
      if (broser.match(/MicroMessenger/i) == 'micromessenger') {
          let authUrl = sessionStorage.getItem("iOS-URL") || null;
          if(authUrl == null) {
            return;
          } else {
            this.share(merchantId, authUrl);
          }
        // // 设备判断
        // let ua = navigator.userAgent;
        // // Android
        // let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1;
        // // iOS
        // let isIos = !!window.__wxjs_is_wkwebview;
        // // IOS
        // if (isIos) {
        //   let authUrl = sessionStorage.getItem("iOS-URL") || null;
        //   if(authUrl == null) {
        //     let path = window.location.href;
        //     sessionStorage.setItem("iOS-URL", path);
        //     this.share(merchantId, path);
        //   } else {
        //     this.share(merchantId, authUrl);
        //   }
        // }
        // // Android
        // if (isAndroid) {
        //   let path = window.location.href;
        //    this.share(merchantId, path);
        // }
      }
    },
    share(merchantId, path) {
      if (merchantId != null && merchantId != '') {
          let params = {
            merchantId: merchantId,
            shareUrl: path
          };
          getWeChatAutograph(params).then((res) => {
            if (res.code === 200) {
              let newPath = window.location.href;
              let active = localStorage.getItem('loginInfo') || null;
              if (active != null) {
                if (newPath.includes('?')) {
                  newPath = newPath + '&memberId=' + JSON.parse(active).id;
                } else {
                  newPath = newPath + '?memberId=' + JSON.parse(active).id
                }
              } 
              res.link = newPath;
              wexinShare(res)
            }
          })
        }
    }
  },

  beforeUnmount() {
    this.beforeunload();
  },
  unmounted() {
    this.player = null;
    window.removeEventListener('beforeunload', () => this.beforeunload);
  }
}
</script>

<style scoped>
@import url("https://g.alicdn.com/apsara-media-box/imp-web-player/2.16.3/skins/default/aliplayer-min.css");

.teaching {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
}

.teaching-pay {
  display: flex;
  height: 44px;
  line-height: 44px;
  background-color: #fff;
}

.teaching-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.teaching-pay-left {
  flex: 1;
  padding: 0 20px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  border-top: 1px solid #e5e5e5;
}

.teaching-pay-right {
  width: 144px;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #FFFFFF;
  letter-spacing: 0;
  font-weight: 400;
  background-color: red;
}

.teaching-img {
  position: relative;
  height: 0;
  padding-bottom: calc(100% * 212 / 375);
}

.teaching-img img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.teaching-info {
  padding: 15px;
  margin-bottom: 5px;
  text-align: left;
  background-color: #fff;
  overflow: hidden;
}

.teaching-name {
  margin-bottom: 10px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}

.teaching-type-list {
  margin-bottom: 10px;
  display: flex;
}

.teaching-type-each {
  padding: 4px 15px;
  min-width: 48px;
  margin-right: 10px;
  font-family: PingFangHK-Regular;
  font-size: 12px;
  color: #666666;
  letter-spacing: -0.07px;
  text-align: center;
  font-weight: 400;
  background: #FAFAFA;
  border: 1px solid #E5E5E5;
  border-radius: 14px;
}

.teaching-price-all {
  display: flex;
  justify-content: space-between;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  text-align: right;
  font-weight: 400;
}

.teaching-price.green {
  color: #13D275;
}

.teaching-price.red {
  color: #F11515;
}

.teaching-title {
  padding: 10px 0;
  margin-bottom: 5px;
  display: flex;
  background-color: #fff;
}

.teaching-title-each {
  width: 50%;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  font-weight: 400;
}

.teaching-title-each.select {
  color: #0095D9;
}

.teaching-descInfo {
  padding: 12px 15px;
  flex: 1;
  background-color: #fff;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 400;
  text-align: left;
}

.teaching-list {
  flex: 1;
  background-color: #fff;
  overflow-y: auto;
}

.teaching-list-each {
  padding: 15px;
  line-height: 20px;
  display: flex;
  border-bottom: 1px solid #e5e5e5;
}

.teaching-list-each:last-child {
  border-bottom: 0;
}

.teaching-list-index {
  min-width: 23px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}

.teaching-list-name {
  flex: 1;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  text-align: left;
  overflow: hidden;
  /* 确保超出容器的内容被裁剪 */
  white-space: nowrap;
  /* 确保文本在一行内显示 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
}

.teaching-status {
  line-height: 18px;
  min-width: 48px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #F11515;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
  background: #FFFFFF;
  border: 1px solid #F11515;
  border-radius: 10px;
}

.teaching-status-icon {
  line-height: 18px;
  min-width: 48px;
  text-align: center;
}

.teaching-status.blue {
  color: #0095D9;
  border: 1px solid #0095D9;
}

.teaching-video {
  position: absolute;
  width: 100%;
  height: 100%;
}

.teaching-video :deep(.prism-auto-stream-selector) {
  display: none;
}

.teaching-lock-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url('../assets/image/teaching-lock-icon.png');
}

.teaching-doing {
  color: #0095D9;
}
</style>